import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";
import Individual from "./Individual";
import Beneficiary from "./Beneficiary";

export default class IavAccount extends Model {

    static entity = 'Household\\Model\\IavAccount';

    static TYPE_CHECKING = 0;
    static TYPE_TAX_QUALIFIED = 1;
    static TYPE_NON_QUALIFIED = 2;
    static TYPE_IRA = 3;
    static TYPE_ROTH = 4;
    static TYPE_401K403B = 5;
    static TYPE_457 = 6;
    static TYPE_SEP = 7;
    static TYPE_SIMPLE_IRA = 8;
    static TYPE_DEFERRED_COMP = 9;
    static TYPE_RETIREMENT_OTHER = 10;
    static TYPE_OTHER = 11;
    static TYPE_JTWROS = 12;
    static TYPE_TBE = 13;
    static TYPE_INDIVIDUAL = 14;
    static TYPE_SAVINGS = 15;
    static TYPE_CD = 16;
    static TYPE_529 = 17;
    static TYPE_UTMA = 18;
    static TYPE_LLC = 19;
    static TYPE_BIRA = 20;
    static TYPE_MM = 21;
    static TYPE_TRUST = 22;
    static TYPE_TOD = 23;
    static TYPE_OTHER_BK = 24;
    static TYPE_BROTH = 25;
    static TYPE_JOINT = 26;


    static OWNER_INDIVIDUAL = 0;
    static OWNER_JOINT = 1;
    static OWNER_TRUST = 2;
    static OWNER_BENEFICIARY = 3;
    static OWNER_OTHER = 4;
    static OWNER_BUSINESS = 5;


    static RETIREMENT_ACCOUNT_TYPES = [
        IavAccount.TYPE_401K403B,
        IavAccount.TYPE_SEP,
        IavAccount.TYPE_IRA
    ]

    static TYPE_LABELS = {
        [IavAccount.TYPE_CHECKING]:  'Checking',
        [IavAccount.TYPE_TAX_QUALIFIED]: 'Tax Qualified',
        [IavAccount.TYPE_NON_QUALIFIED]: 'Non Qualified',
        [IavAccount.TYPE_IRA]: 'IRA',
        [IavAccount.TYPE_ROTH]: 'Roth',
        [IavAccount.TYPE_401K403B]: '401k/403b',
        [IavAccount.TYPE_457]: '457',
        [IavAccount.TYPE_SEP]: 'SEP',
        [IavAccount.TYPE_SIMPLE_IRA]: 'Simple IRA',
        [IavAccount.TYPE_DEFERRED_COMP]: 'Deferred Comp',
        [IavAccount.TYPE_RETIREMENT_OTHER]: 'Retirement Other',
        [IavAccount.TYPE_OTHER]: 'Other',
        [IavAccount.TYPE_JTWROS]: 'Joint TOD',
        [IavAccount.TYPE_TBE]: 'TBE',
        [IavAccount.TYPE_INDIVIDUAL]: 'Individual',
        [IavAccount.TYPE_SAVINGS]: 'Savings',
        [IavAccount.TYPE_CD]: 'CD',
        [IavAccount.TYPE_529]: '529',
        [IavAccount.TYPE_UTMA]: 'UTMA',
        [IavAccount.TYPE_LLC]: 'LLC',
        [IavAccount.TYPE_BIRA]: 'Beneficiary IRA',
        [IavAccount.TYPE_MM]: 'M/M',
        [IavAccount.TYPE_TRUST]: 'Trust',
        [IavAccount.TYPE_TOD]: 'TOD',
        [IavAccount.TYPE_OTHER_BK]: 'Other',
        [IavAccount.TYPE_BROTH]: 'Beneficiary Roth IRA',
        [IavAccount.TYPE_JOINT]: 'Joint',
    }

    static BANK_ACCOUNT_TYPES = [
        IavAccount.TYPE_CHECKING,
        IavAccount.TYPE_SAVINGS,
        IavAccount.TYPE_CD,
        IavAccount.TYPE_MM,
        IavAccount.TYPE_OTHER_BK
    ];

    static TAX_QUALIFIED_ACCOUNT_TYPES = [
        IavAccount.TYPE_TAX_QUALIFIED,
        IavAccount.TYPE_IRA,
        IavAccount.TYPE_ROTH,
        IavAccount.TYPE_BIRA,
        IavAccount.TYPE_401K403B,
        IavAccount.TYPE_457,
        IavAccount.TYPE_SEP,
        IavAccount.TYPE_SIMPLE_IRA,
        IavAccount.TYPE_DEFERRED_COMP,
        IavAccount.TYPE_RETIREMENT_OTHER
    ]

    static NON_QUALIFIED_ACCOUNT_TYPES = [
        IavAccount. TYPE_NON_QUALIFIED,
        IavAccount.TYPE_TBE,
        IavAccount.TYPE_INDIVIDUAL,
        IavAccount.TYPE_TOD,
        IavAccount.TYPE_JOINT,
        IavAccount.TYPE_JTWROS,
        IavAccount.TYPE_TRUST,
        IavAccount.TYPE_LLC,
        IavAccount.TYPE_529,
        IavAccount.TYPE_UTMA,
        IavAccount.TYPE_OTHER
    ]

    static fields() {
        return {
            id: this.attr(null),
            household_id: this.number(null),
            beneficiary_id: this.number(null),
            individual_id: this.number(null),
            account_number: this.attr(null),
            owner: this.number(null),
            name: this.attr(null),
            type_of_account_cd: this.attr(null),
            company_name: this.attr(null),
            value: this.number(null),
            emergency_funds: this.number(0),
            plan_status_cd: this.attr(null),
            notes: this.attr(null),
            individual: this.belongsTo(Individual, 'individual_id'),
            beneficiary: this.belongsTo(Beneficiary, 'beneficiary_id'),
            beneficiaryAssignments: this.morphMany(BeneficiaryAssignment, 'assignable_id', 'assignable_type'),
            /* todo: map other fields */
        }
    }

    get typeLabel() {
        return IavAccount.TYPE_LABELS[this.type_of_account_cd];
    }


    get ownerLabel() {
        switch (this.owner) {
            case IavAccount.OWNER_INDIVIDUAL:
                return this.individual?.name;
            case IavAccount.OWNER_BENEFICIARY:
                return this.beneficiary?.first_name
            case IavAccount.OWNER_JOINT:
                return 'Joint'
            case IavAccount.OWNER_TRUST:
                return 'Trust'
            case IavAccount.OWNER_BUSINESS:
                return 'Business'
            default:
                return 'Other'
        }
    }

    get isRetirementMoney() {
        return IavAccount.RETIREMENT_ACCOUNT_TYPES.includes(this.type_of_account_cd)
    }

    get accountsOverviewName() {
        return this.account_number ?? this.name ?? this.ownerLabel;
    }

    get accountsOverviewValue() {
        return this.value;
    }
}
